import { useState, useEffect } from 'react';
import { AdvancedChateauFilterService, AdvancedFilterCriteria, ChateauWithFilters } from '@/services/advancedChateauFilterService';

interface UseAdvancedChateauFilteringProps {
  chateaux: any[];
}

export const useAdvancedChateauFiltering = ({ chateaux }: UseAdvancedChateauFilteringProps) => {
  const [criteria, setCriteria] = useState<AdvancedFilterCriteria>({});
  const [filteredChateaux, setFilteredChateaux] = useState<ChateauWithFilters[]>([]);

  const updateFilteredChateaux = () => {
    // Convertir les châteaux au format attendu
    const formattedChateaux: ChateauWithFilters[] = chateaux.map(chateau => ({
      id: chateau.id,
      nom: chateau.nom,
      taille: chateau.taille,
      capacite: chateau.capacite,
      prix: chateau.prix,
      description: chateau.description,
      caracteristiques: chateau.caracteristiques || [],
      age_recommande: chateau.age_recommande || chateau.ageRecommande || "3-12 ans",
      theme: chateau.theme,
      surface: chateau.surface,
      features: chateau.features || chateau.caracteristiques || []
    }));

    const filtered = AdvancedChateauFilterService.filterChateaux(formattedChateaux, criteria);
    setFilteredChateaux(filtered);
  };

  // Auto-update filtered châteaux when criteria or chateaux change
  useEffect(() => {
    updateFilteredChateaux();
  }, [criteria, chateaux]);

  const resetFilters = () => {
    setCriteria({});
  };

  const hasActiveFilters = Object.keys(criteria).some(key => {
    const value = criteria[key as keyof AdvancedFilterCriteria];
    return value && (Array.isArray(value) ? value.length > 0 : value !== "");
  });

  return {
    criteria,
    setCriteria,
    filteredChateaux,
    resetFilters,
    hasActiveFilters,
    resultsCount: filteredChateaux.length,
    
    // Options pour les filtres
    spaceOptions: AdvancedChateauFilterService.getSpaceOptions(),
    budgetOptions: AdvancedChateauFilterService.getBudgetOptions(),
    ageOptions: AdvancedChateauFilterService.getAgeOptions(),
    themeOptions: AdvancedChateauFilterService.getThemeOptions(),
    sizeOptions: AdvancedChateauFilterService.getSizeOptions(),
    featureOptions: AdvancedChateauFilterService.getFeatureOptions()
  };
};